import React from "react";
import Typography from "../Typography";

const Card = ({
  title,
  value,
  icon,
  bgColor,
  additionalContent,
  className = "",
  valueClassName = "",
  titleClassName = "",
}) => {
  return (
    <div className={`shadow-md p-4 sm:p-6 ${bgColor} ${className}`}>
      <div className="flex items-center justify-between">
        <div className={additionalContent ? "flex-1" : ""}>
          <Typography
            variant="h2"
            className={`text-white font-bold text-xl sm:text-2xl ${titleClassName}`}
          >
            {title}
          </Typography>
          <Typography
            variant="text2"
            className={`text-white mt-2 opacity-90 md:text-2xl ${valueClassName}`}
          >
            {value}
          </Typography>
          {additionalContent && additionalContent}
        </div>
        {icon && (
          <div className="w-[40px] h-[40px] bg-white rounded flex items-center justify-center mt-11">
            {typeof icon === "string" ? (
              <svg
                className="w-6 h-6 sm:w-8 sm:h-8 text-dark"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={icon} />
              </svg>
            ) : (
              icon
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;
